export enum ActionType {
  CREATE_NEW_CALENDAR_EVENT = 'CREATE_NEW_CALENDAR_EVENT',
  DELETE_CALENDAR_EVENT = 'DELETE_CALENDAR_EVENT',
  EDIT_CALENDAR_EVENT = 'EDIT_CALENDAR_EVENT',
  RESCHEDULE_CALENDAR_EVENT = 'RESCHEDULE_CALENDAR_EVENT',
  SET_DATE_TO_TODAY = 'SET_DATE_TO_TODAY',
  SET_SELECTED_DATE = 'SET_SELECTED_DATE',
  SWITCH_TO_A_MONTH_AGO = 'SWITCH_TO_A_MONTH_AGO',
  SWITCH_TO_ONE_MONTH_FORWARD = 'SWITCH_TO_ONE_MONTH_FORWARD',
  PAGE_WAS_LOADED = 'PAGE_WAS_LOADED',
  OPEN_EVENT_CREATOR_WINDOW = 'OPEN_EVENT_CREATOR_WINDOW',
  CLOSE_EVENT_CREATOR_WINDOW = 'CLOSE_EVENT_CREATOR_WINDOW',
  OPEN_EVENT_MODAL_POPUP = 'OPEN_EVENT_MODAL_POPUP',
  CLOSE_EVENT_MODAL_POPUP = 'CLOSE_EVENT_MODAL_POPUP',
  SET_MOUSE_COORDINATES = 'SET_MOUSE_COORDINATES',
  SWITCH_TO_A_MINUS_ONE_DAY = 'SWITCH_TO_A_MINUS_ONE_DAY',
  SWITCH_TO_A_ONE_DAY_FORWARD = 'SWITCH_TO_A_ONE_DAY_FORWARD',
  DAY_COMPONENT_WAS_LOADED = 'DAY_COMPONENT_WAS_LOADED',
  MONTH_COMPONENT_WAS_LOADED = 'MONTH_COMPONENT_WAS_LOADED',
  SET_SELECTED_EVENT_ID = 'SET_SELECTED_EVENT_ID',
  ADD_NEW_EVENT_TO_LIST = 'ADD_NEW_EVENT_TO_LIST',
  UPDATE_EVENT_DATA = 'UPDATE_EVENT_DATA',
  SHOW_LOGIN_WINDOW = 'SHOW_LOGIN_WINDOW',
  HIDE_LOGIN_WINDOW = 'HIDE_LOGIN_WINDOW',
  CHANGE_CALENDAR_VIEW = 'CHANGE_CALENDAR_VIEW',
}
